import { getEditor, isEnabled } from '../composables/editorsMap';
import InsertTable from '../menuItemComponents/InsertTable.vue';
import { Table } from 'lucide-vue-next';
export const getTableOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'table'),
    icon: Table,
    title: 'טבלה',
    type: 'select',
    loseFocus: true,
    component: InsertTable,
    props: {},
    action: ({ rows, cols, withHeaderRow }) => {
      editor?.chain().focus().addSpaceBefore().run();
      editor.chain().insertTable({ rows, cols, withHeaderRow }).run();
      editor
        .chain()
        .insertContentAt(getEditor(id).value?.state.doc.content.size, '<p></p>')
        .run();
    },
    isActive: () => editor?.isActive('table'),
  };
};
